import { FighterToWatch } from '../../../../../../../corelogic/domain/models/hub.model';

export const fightersToWatch: FighterToWatch[] = [
  {
    name: 'Dustin Poirier',
    description:
      'Elite veteran and former interim champion competing for the BMF title in his retirement fight',
    fightId: '0ad62c509f2c5b869bac9d3465f039c0',
  },
  {
    name: 'Reinier de Ridder',
    description: 'Former ONE FC champion, on a 3 fight hot streak in the UFC',
    fightId: 'c4723e908c185203a0df67a1ef3062e9',
  },
  {
    name: 'Khamzat Chimaev',
    description:
      'One of the most feared fighters in the UFC, making his much anticipated title fight debut',
    fightId: 'f229dc89e3795f18b9e08b86423c041a',
  },
  {
    name: 'Kai Asakura',
    description:
      'Dynamic striker with knockout power and exciting fighting style. Looking to bounce back from his recent title fight loss',
    fightId: '66638061499e5de988a3268d4c712bbe',
  },
  {
    name: 'Aaron Pico',
    description:
      'Hotly tipped prospect and decorated world-level wrestler, looking for a statement win in his UFC debut',
    fightId: 'ad9b880cfe125787860a9320ab68f143',
  },
];
